module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002-fr.05da09e.webp";